module.exports = __webpack_public_path__ + "21c1ff1f4bebbdf2f08aa35a544c1261.svg";